import { createAction } from "../base/action";

export const toggleMenu = createAction("TOGGLE_MENU", (show?:boolean) => {
    return {menu:show};
});

export const toggleProjects = createAction("TOGGLE_PROJECTS", (show?:boolean) => {
    return {projects:show};
});